const INTERACTIVE_COMPLETED_KEY = 'interactive_tutorial_completed';

export const INTERACTIVE_TUTORIAL_PENDING_KEY = 'interactive_tutorial_pending';

// Set when the user clicks "Review Session" from the Session Ended modal
// while the interactive tour is active, so SessionDetailPage knows to show a
// one-off tip pointing at the feedback content once it mounts.
export const TUTORIAL_FEEDBACK_TIP_PENDING_KEY = 'tutorial_feedback_tip_pending';

export function isInteractiveCompleted(): boolean {
  try {
    return localStorage.getItem(INTERACTIVE_COMPLETED_KEY) === 'true';
  } catch {
    return false;
  }
}

export function markInteractiveCompleted(): void {
  try {
    localStorage.setItem(INTERACTIVE_COMPLETED_KEY, 'true');
  } catch {
    // Storage full or unavailable
  }
}

export function setPending(key: string): void {
  try {
    localStorage.setItem(key, 'true');
  } catch {
    // Storage full or unavailable
  }
}

/**
 * Read-only check, safe to call repeatedly (e.g. before a delayed consume)
 * without affecting the flag.
 */
export function isPending(key: string): boolean {
  try {
    return localStorage.getItem(key) === 'true';
  } catch {
    return false;
  }
}

/**
 * Atomic read-and-remove so React StrictMode's double-invoked effects
 * can't consume the same pending flag twice.
 */
export function consumePending(key: string): boolean {
  try {
    const value = localStorage.getItem(key) === 'true';
    localStorage.removeItem(key);
    return value;
  } catch {
    return false;
  }
}
